/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import { useFormikContext } from 'formik'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import {
  PLUGIN_VIEW_OPTIONS,
  PLUGIN_VIEW_TABS,
  setPluginTabHidden,
  type PluginEmbedSettings,
} from '@sportninja/common/features/account/apiAccess'
import { PLUGIN_TAB_SECTION_COPY } from '../../constants/pluginSettings'
import { SettingSwitch } from './SettingSwitch'
import { SettingsSection } from './SettingsSection'

/**
 * One section per page type, whatever Embed starts on: the plugin can show the
 * other page types too, and each type keeps its own hidden tabs. Off hides the
 * tab.
 */
export const TabsGroup = () => {
  const { values, setFieldValue } = useFormikContext<PluginEmbedSettings>()
  const { view: entryView, hiddenTabs } = values

  return (
    <div css={groupStyle}>
      {PLUGIN_VIEW_OPTIONS.map(({ label, value: view }) => (
        <SettingsSection
          key={view}
          title={label}
          description={
            view === entryView
              ? PLUGIN_TAB_SECTION_COPY.entry
              : PLUGIN_TAB_SECTION_COPY.other
          }
        >
          <div css={gridStyle}>
            {PLUGIN_VIEW_TABS[view].map(({ key, label: tabLabel }) => (
              <SettingSwitch
                key={key}
                label={capitalizeWords(tabLabel)}
                checked={!hiddenTabs[view].includes(key)}
                onChange={(shown) =>
                  setFieldValue(
                    'hiddenTabs',
                    setPluginTabHidden(hiddenTabs, view, key, !shown)
                  )
                }
              />
            ))}
          </div>
        </SettingsSection>
      ))}
    </div>
  )
}

const groupStyle = css`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const gridStyle = css`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
`
